// The kit's checkbox track sits too light against the rail in both themes, so
// the boxes take the same fill and border as the header search control and
// the lab cards.
.checkbox-input {
	// The control radius every other box on the site uses (4px).
	border-radius: var(--surreal-radius-control);

	&:not(:checked) {
		background-color: var(--docs-card);
		border-color: var(--surreal-border-default);

		@include light {
			background-color: var(--mantine-color-white);
			border-color: var(--surreal-border-default);
		}
	}

	// Solid product accent for the checked fill, not the kit's gradient.
	&:checked {
		background: var(--docs-accent);
		border-color: var(--docs-accent);
	}
}
